import {
  ContentModule,
  ContentModuleType,
  PostType,
} from '@tribeplatform/gql-client/types'
import { I18nShape } from '@tribeplatform/react-components/i18n'
import { PostTypePermission } from '@tribeplatform/react-components/Space'
import { ButtonVariant } from '@tribeplatform/react-ui-kit/Button'

import { ButtonActionType } from '../../../types.js'
import { getTranslatedAddPostText } from '../../utils.js'

export const getButtonVariant = (type: ButtonActionType): ButtonVariant => {
  switch (type) {
    case ButtonActionType.PrimaryButton:
      return 'primary'
    case ButtonActionType.NeutralButton:
      return 'secondaryNeutral'
    default:
      return 'secondary'
  }
}

interface ContentTypeDetailsParams {
  intl: I18nShape
  contentType: PostType | ContentModuleType
  postTypePermissions?: Record<string, PostTypePermission>
}

export const getContentTypeDetails = ({
  intl,
  contentType,
  postTypePermissions,
}: ContentTypeDetailsParams): {
  label: string
  onlyAdminsCanPost?: boolean
} => {
  const { $t } = intl
  if (isPostType(contentType)) {
    return {
      label: getTranslatedAddPostText(intl, contentType.name),
      onlyAdminsCanPost:
        postTypePermissions?.[contentType.id]?.whoCanPost === 'admins',
    }
  }

  switch (contentType) {
    case ContentModuleType.event:
      return {
        label: $t({
          defaultMessage: 'Add event',
          id: 'Space.Actions.AddEvent',
        }),
        /**
         * @todo: currently only admins can create events. Should check for the permission
         * once other users can create events
         */
        onlyAdminsCanPost: true,
      }
    default: {
      const unknownContentModuleType: never = contentType
      return unknownContentModuleType
    }
  }
}

export const isPostType = (
  content: PostType | ContentModule | ContentModuleType,
): content is PostType => {
  return (
    typeof content === 'object' &&
    content !== null &&
    'id' in content &&
    'slug' in content
  )
}
